define('bizzabo/views/right/EditSessionView',[
    'jquery',
    'jquery-timepicker',
    'backbone',
    'underscore',
    'bizzabo/config',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/models/Global',
    'bizzabo/models/Speaker',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'bizzabo/views/popup/EditSpeakerView',
    'bizzabo/views/right/AgendaErrorsView',
    'bizzabo/views/popup/DeleteSessionView',
    'hbars!bizzabo/templates/editSession',
    'hbars!bizzabo/templates/editSessionTrack',
    'hbars!bizzabo/templates/editSessionSpeaker'
], function(
    $,
    jQueryTimepicker,
    Backbone,
    _,
    CONFIG,
    UTILS,
    Consts,
    Global,
    Speaker,
    FormMixin,
    ModelBindingMixin,
    EditSpeakerView,
    AgendaErrorsView,
    DeleteSessionView,
    editSessionTemplate,
    editSessionTrackTemplate,
    editSessionSpeakerTemplate
    ) {

    var EditSessionView = Backbone.View.extend({

        events : {
            'click .push-message-box-tab': 'tabClicked',

            // Form changes
            'change select[name="day"]' : "formDayChanged",
            'change input[name="start"]' : "formStartChanged",
            'change input[name="end"]' : "formEndChanged",

            // Dates
            'showTimepicker input[name="end"]' : "overwriteEndTimePickerZeroOption",

            // Speakers
            'autocompleteselect input[name="speaker"]' : "formSpeakerAdded",
            'focus input[name="speaker"]' : "openSpeakerAutoComplete",
            'blur input[name="speaker"]' : "formSpeakerBlurred",
            'click .add-new-speaker' : "addNewSpeakerNoName",

            // Actions
            'click [name="deleteSessionBtn"]' : "formRemoveSession",
            'click .doneSessionBtn' : "saveClicked",
            'keydown .doneSessionBtn' : "saveKeyClicked"
        },

        keyPressValidationFields : ["name", "description", "location"],
        modelBindingBlackList : ["ranking", "isColliding", "client-id"],
        noAutoVFields : ['start', 'end', 'duration', 'isColliding'],

        tagName : "article",
        speakersAutoCompleteList : [],
        timeErrorFieldMsgs : {
            isColliding : "",
            duration : "",
            start : "",
            end : ""
        },
        endTimePickerMinTimeMinutes : undefined,
        endTimePickerMinTime : undefined,
        speakersSectionSubView : undefined,
        tracksSectionSubView : undefined,
        alreadyFocused : undefined,
        dayView : undefined,

        initialize : function() {
            this.dayView = this.options.dayView;
            this.event = Global.modelPool.getActiveEvent();
            this.agenda = this.dayView.editAgendaView.model;

            UTILS.mixIntoMe(this, FormMixin); // mixin standard form & validation
            UTILS.mixIntoMe(this, ModelBindingMixin); // mixin model binding

            this.listenTo(this.model, 'change:start', this.setEndTimePicker);
            this.listenTo(this.model, 'speakerRelation:add speakerRelation:remove', this.updateSpeakersAutoCompleteList);
            this.listenTo(this.model, 'validated', this.postValidation);
            this.listenTo(this.event, 'change:start-date, change:end-date', this.modelEventDatesChanged);
            this.listenTo(Backbone, Consts.Notifications.rightPanel.SWITCHED, this.onReady);

            this.initModelBinding();
            this.initValidation();

            if (CONFIG.ALLOW_IMPORT_AGENDA) {
                this.agendaErrorsView = new AgendaErrorsView({
                    model: this.agenda,
                    el: this.$('.agenda-errors-view')
                });
                this.listenTo(this.agenda, 'agendaValidated', _.debounce(this.activeAgendaValidated, 300));
            }
        },

        remove : function() {
            this.removeModelBinding();
            this.removeValidation();
            this.$('input[name=speaker]').unbind('paste');
            this.tracksSectionSubView && this.tracksSectionSubView.remove();
            this.speakersSectionSubView && this.speakersSectionSubView.remove();
            this.agendaErrorsView && this.agendaErrorsView.remove();
            return Backbone.View.prototype.remove.call(this);
        },

        activeAgendaValidated: function(isValid, model, numberOfErrors) {
            var shouldValidate = (this.model.wasEdited || this.model.isSynced);
            if (!shouldValidate) {
                var cid = this.model.cid;
                UTILS.applyRecursively(this.agenda.dayErrors, function(obj, value, key) {
                    if (key == cid) {
                        numberOfErrors = numberOfErrors - _.size(value);
                    }
                });
            }

            var element = this.$('.error-counter-bubble');
            if (numberOfErrors <= 0) {
                element.empty().addClass('hide');
            } else {
                element.text(numberOfErrors).removeClass('hide');
            }
        },

        tabClicked: function(e) {
            var tabName = $(e.target).attr('name') || $(e.target.parentElement).attr('name');
            this.switchToTab(tabName);
        },

        switchToTab: function(tabName) {
            var types = {
                'session': false,
                'agenda-errors': false
            };
            types[tabName] = true;
            _.each(types, function(value, key) {
                this.$('.push-message-box-tab.' + key).toggleClass('selected', value);
                this.$('.push-messages-image.' + key).toggleClass('hide', !value);
                this.$('.edit-session-view-content.' + key).toggleClass('hide', !value);
            }, this);

            if (tabName == 'agenda-errors') {
                Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, 'event/' + (this.event.id || 'new') + '/agenda', {
                    trigger : false
                });
            }
        },

        setFocusToField : function(fieldSelector, noScroll) {
            var focusField = this.$(fieldSelector);
            var focusFieldExists = (focusField.length > 0);
            if (!focusFieldExists) {
                return;
            }
            var scroller = this.$('.possibleScroll');
            _.defer(function() {
                if (noScroll) {
                    UTILS.UI.focusOnField(focusField);
                } else {
                    var offsetFromTop = 25;
                    scroller.animate({
                        scrollTop : focusField.offset().top - scroller.offset().top + scroller.scrollTop() - offsetFromTop
                    }, 700, UTILS.ui.focusOnField(focusField));
                }
            });
        },

        render : function() {
            var thisDay = this.dayView.model;
            var html = editSessionTemplate({
                session : this.model,
                event : this.event,
                enableImportExport: CONFIG.ALLOW_IMPORT_AGENDA,
                numberOfAgendaErrors: this.agenda.numberOfErrors(),
                hasAgendaErrors: (this.agenda.numberOfErrors() > 0)
            });
            this.$el.html(html);
            this.agendaErrorsView && this.agendaErrorsView.setElement(this.$('.agenda-errors-view')).render();
            this.$('select[name="day"]').val(thisDay.get('index')).trigger("chosen:updated");

            this.tracksSectionSubView && this.tracksSectionSubView.remove();
            this.tracksSectionSubView = new TracksSectionSubView({
                model : thisDay.get("track"),
                editSessionView : this
            });
            this.tracksSectionSubView.$el = this.$(".tracksDiv");
            this.tracksSectionSubView.render();

            this.updateSpeakersAutoCompleteList();
            this.initSpeakerAutoComplete();

            this.speakersSectionSubView && this.speakersSectionSubView.remove();
            this.speakersSectionSubView = new SpeakersSectionSubView({
                model : this.dayView.editAgendaView.model.get("relation-session-speaker"),
                editSessionView : this
            });
            this.speakersSectionSubView.$el = this.$("div.speakers");
            this.speakersSectionSubView.render();

            this.$('input[name="start"]').timepicker({
                className : 'startTimePicker session-date-picker',
                maxTime : '11:59pm'
            });
            this.setEndTimePicker();

            if (!this.alreadyFocused) {
                this.alreadyFocused = true;
                this.setFocusToField('textarea[name="name"]', true);
            }

            return this;
        },

        onReady : function() {
            this.renderForm();
            this.disableViewIfNeed();
            var autoFocusField = this.options.deepLinkParams && this.options.deepLinkParams.field;
            autoFocusField && this.setFocusToField('[name=' + autoFocusField + ']');
        },

        disableViewIfNeed : function() {
            if (Global.modelPool.getActiveEvent().get('event-is-active')) {
                this.$('input, textarea').attr('disabled', 'disabled');
                this.$('.btnEffect, .deleteLabel, .doneSessionBtn').toggleClass('hide', true);
            } else {
                this.$('input, textarea').removeAttr('disabled', 'disabled');
                this.$('.btnEffect, .deleteLabel, .doneSessionBtn').toggleClass('hide', false);
            }
        },

        setEndTimePicker : function() {
            var startMinutes = UTILS.timeStringToMinutes(this.model.get("start"));
            this.endTimePickerMinTimeMinutes = startMinutes + Consts.UI.agenda.MIN_SESSION_DURATION;
            this.endTimePickerMinTime = UTILS.ensureAmPmFormat(UTILS.minutesToTimeString(this.endTimePickerMinTimeMinutes));

            var durationTime = UTILS.ensureAmPmFormat(this.model.get("start"));
            this.$('input[name="end"]').timepicker({
                className : 'endTimePicker session-date-picker',
                minTime : durationTime,
                durationTime : durationTime,
                maxTime : '11:59pm',
                showDuration : true
            });
        },

        overwriteEndTimePickerZeroOption : function() {
            var zeroLi = this.$('.endTimePicker li:first-child');
            var innerHtml = this.endTimePickerMinTime + '<span class="ui-timepicker-duration">(' + Consts.UI.agenda.MIN_SESSION_DURATION + ' mins)</span>';
            zeroLi.html(innerHtml);
            zeroLi.data({
                time : this.endTimePickerMinTimeMinutes * 60
            });
        },

        initSpeakerAutoComplete : function() {
            var thisView = this;
            var input = this.$('input[name=speaker]');
            input.autocomplete({
                source : function(termObject, cb) {
                    var res = [];
                    res.push({
                        label : " Add '" + termObject.term + "' as a new speaker",
                        value : termObject.term,
                        cid : "new"
                    });
                    if (termObject.term.length === 0) {
                        res[0].label = "Type name to add a new speaker";
                        res[0].cid = "";
                    }

                    var relevantSpeakers = thisView.speakersAutoCompleteList;
                    if (relevantSpeakers.length > 0) {
                        var lowerTerm = termObject.term.toLowerCase();
                        for (var speakerIndex in relevantSpeakers) {
                            var optionObject = relevantSpeakers[speakerIndex];
                            var name = optionObject.label.toLowerCase();
                            if (name.indexOf(lowerTerm) > -1) {
                                res.push(relevantSpeakers[speakerIndex]);
                            }
                        }
                    }

                    if (cb) {
                        cb(res);
                    }
                },
                minLength : 0,
                delay : 0,
                autoFocus : true
            });
            input.data( "ui-autocomplete" )._renderItem = function( ul, item ) {
                var parentAnchor = $( "<a>" ).addClass('autocomplete-text-overides');
                var li = $( "<li>" ).attr( "data-value", item.value )
                                    .addClass('autocomplete-list-item')
                                    .data( "ui-autocomplete-item", item )
                var a = $( "<a>" ).text( item.label).addClass('autocomplete-text-overides');

                if (item['photo-url'] != undefined) {
                var photoUrl = item['photo-url'].length == 0 ? 'images/agenda/avatar_5.jpg' : item['photo-url'];
                parentAnchor = $(parentAnchor).append( $( "<img>" ).addClass('autocomplete-img').attr('src', photoUrl));
                a = $(a).addClass('autocomplete-text');
                };

                parentAnchor.append(a);
                li.append(parentAnchor);
                return li.appendTo( ul );
            };

            input.bind('paste', function () {
                setTimeout(function() {
                    input.autocomplete('search', input.val());
                }, 0);
            });
        },

        updateSpeakersAutoCompleteList : function() {
            var agendaModel = this.dayView.editAgendaView.model;
            var allSpeakers = agendaModel.get("speaker");
            var allSpeakersCids = _.pluck(allSpeakers.models, "cid");
            var thisSpeakers = agendaModel.getSpeakersForSession(this.model);
            var tempCollection = new Backbone.Collection(thisSpeakers);
            var thisSpeakersCids = _.pluck(tempCollection.models, "cid");
            if (thisSpeakers && allSpeakers && allSpeakersCids.length) {
                var relevantSpeakersCid = _.difference(allSpeakersCids, thisSpeakersCids);
                var res = [];
                for (var speakerCidIndex in relevantSpeakersCid) {
                    var speakerCid = relevantSpeakersCid[speakerCidIndex];
                    var speaker = allSpeakers.get(speakerCid);
                    var displayLabel = speaker.getFullName();
                    res.push({
                        label : displayLabel,
                        //value : speaker.cid
                        value : displayLabel,
                        cid : speaker.cid,
                        'photo-url' : speaker.get('photo-url')
                    });
                }
                this.speakersAutoCompleteList = res;
            }
        },

        postValidation : function() {
            this.updateTimeField();
        },

        // @override
        setErrorIndicator : function(view, attr, error, drawOk) {
            if (_.indexOf(["ranking"], attr) > -1) {
                return;
            }
            if (_.indexOf(["start", "end", "duration", "isColliding"], attr) > -1) {
                view.setTimeFieldErrorIndicator(view, attr, error);
            } else {
                view.setFieldErrorIndicator(view, attr, error, drawOk);
            }
        },

        setTimeFieldErrorIndicator : function(view, attr, error) {
            view.timeErrorFieldMsgs[attr] = error ? error : "";
        },

        updateTimeField : function() {
            var collision = this.timeErrorFieldMsgs["isColliding"];
            var duration = this.timeErrorFieldMsgs["duration"];
            var start = this.timeErrorFieldMsgs["start"];
            var end = this.timeErrorFieldMsgs["end"];

            var startElement = this.$('[name="start"]');
            var endElement = this.$('[name="end"]');
            var errorMsgElement = this.$('.timeErrorMsg');

            var hasCollisionOrDuration = collision.length + duration.length;
            var markStartFieldAsValid = (hasCollisionOrDuration + start.length) === 0;
            this.markFieldValidation(startElement, markStartFieldAsValid, true);

            var markEndFieldAsValid = (hasCollisionOrDuration + end.length) === 0;
            this.markFieldValidation(endElement, markEndFieldAsValid, true);

            var errorMsgToDisplay = "";
            var priorities = [start, end, duration, collision];
            var priorityIndex = 0;
            while (errorMsgToDisplay.length === 0 && priorityIndex < priorities.length) {
                errorMsgToDisplay = priorities[priorityIndex];
                priorityIndex++;
            }
            this.animateErrorMsg(errorMsgElement, errorMsgToDisplay);
        },

        /****** Model Changes ******/

        modelEventDatesChanged : function() {
            this.render();
        },

        modelDayChanged : function() {
            this.$('select[name="day"]').val(this.dayView.model.get('index')).trigger("chosen:updated");
        },

        modelStartChanged : function(model, params) {
            if (params && params.fromForm) {
                return;
            }
            var amPm = UTILS.ensureAmPmFormat(this.model.get('start'));
            this.$('input[name="start"]').val(amPm);
        },

        modelEndChanged : function(model, params) {
            if (params && params.fromForm) {
                return;
            }
            var amPm = UTILS.ensureAmPmFormat(this.model.get('end'));
            this.$('input[name="end"]').val(amPm);
        },

        modelDurationChanged : function(model, params) {
            if (params && params.fromForm) {
                return;
            }
            this.$('input[name="duration"]').val(this.model.get('duration'));
        },

        /****** Form Changes ******/

        formDayChanged : function() {
            var newDayString = this.$('select[name="day"]').val();
            var newDayIndex = parseInt(newDayString);
            var dayView = this.dayView;
            var agendaView = dayView.editAgendaView;
            var day = agendaView.model.get("day").where({
                index : newDayIndex
            })[0];
            var newSessionView = agendaView.moveSessionBetweenDays(dayView.model, day, this.model);
            this.dayView = agendaView.dayViews[newDayIndex];
            agendaView.scrollToSessionViewOrDay(newSessionView, agendaView);
            this.tracksSectionSubView.render();
        },

        formStartChanged : function() {
            var newStart = this.$('input[name="start"]').val();
            this.model.setTime({
                start : newStart
            }, true, true);
        },

        formEndChanged : function() {
            var newEnd = this.$('input[name="end"]').val();
            this.model.setTime({
                end : newEnd
            }, true, true);
        },

        openSpeakerAutoComplete : function() {
            this.openAutoComplete("speaker");
        },

        openAutoComplete : function(name) {
            if ($(".ui-autocomplete").is(":hidden")) {
                this.$('input[name=' + name + ']').autocomplete("search", "");
            }
        },

        formSpeakerBlurred : function() {
            this.$("input[name='speaker']").val("");
        },

        addNewSpeakerNoName : function() {
           var ui = {
               item: {
                    cid: "new",
                    label: "",
                    value: ""
               }
           }
            this.formSpeakerAdded(null, ui);
        },

        formSpeakerAdded : function(event, ui) {
            var cid = ui.item.cid;
            if (cid && cid.length > 0) {
                if (cid == "new") {
                    var nameObject = UTILS.splitToFirstAndLastNames(ui.item.value);
                    this.addNewSpeaker(nameObject.first, nameObject.last);
                } else {
                    var allSpeakers = this.dayView.editAgendaView.model.get("speaker");
                    var speaker = allSpeakers.get(cid);
                    this.addSpeakerToSession(speaker);
                }
            }
        },

        addSpeakerToSession : function(speaker) {
            var relation = this.dayView.editAgendaView.model.get("relation-session-speaker");
            relation.addRelation(this.model, speaker);
        },

        saveClicked : function() {
            Backbone.trigger(Consts.Notifications.mainPage.SAVE_ALL_REQUEST);
        },

        saveKeyClicked : function(e) {
            var ev = e || event;
            if (ev.keyCode == 13) {
                this.saveClicked();
                return false;
            }
        },

        addNewSpeaker : function(firstName, lastName) {
            var newSpeaker = new Speaker({
                'first-name' : firstName,
                'last-name' : lastName,
                'newSpeaker': true
            });
            var thisView = this;
            this.editSpeaker(newSpeaker, function() {
                thisView.addEditedSpeaker(newSpeaker, thisView);
            });
        },

        editSpeaker : function(speaker, doneCb) {
            new EditSpeakerView({
                model : speaker,
                editSessionView : this,
                doneCb : doneCb
            }).show();
        },

        addEditedSpeaker : function(speaker, context) {
            if (_.isUndefined(context)) {
                context = this;
            }
            context.dayView.editAgendaView.model.get("speaker").add(speaker);
            context.addSpeakerToSession(speaker);
        },

        formRemoveSession : function() {
            var thisView = this;
            if (this.model.get('registration')) {
                var deleteSessionPopup = new DeleteSessionView(
                    {
                        model: this.model,
                        title: "Delete Session",
                        html: '<p>The selected session and all of its registrants will be deleted. This action cannot be undone. Do you want to continue?</p>',
                        onDelete: function() {
                            thisView.deleteSession();
                        }
                    });
                deleteSessionPopup.show();
            }
            else {
                this.deleteSession();
            }
        },

        deleteSession : function () {
            this.dayView.editAgendaView.unFocusSessionAndShowPreview();
            this.dayView.editAgendaView.model.get("relation-session-speaker").removeAllRelations(this.model);
            this.dayView.model.removeSession(this.model);
        }
    });

    var TracksSectionSubView = Backbone.View.extend({

        trackSubViews : {},
        editSessionView : undefined,
        upperIndex : 0,
        lowerIndex : 0,

        initialize : function() {
            this.editSessionView = this.options.editSessionView;
            this.listenTo(this.model, 'add', this.modelTrackAdded);
            this.listenTo(this.model, 'remove', this.modelTrackRemoved);
            this.listenTo(this.model, 'add remove', this.hideWhenSingleTrack);
            this.listenTo(this.model, 'sessionRelation:add', this.resetIndexes);
            this.listenTo(this.model, 'sessionRelation:remove', this.resetIndexes);
        },

        remove : function() {
            this.removeTrackSubViews();
            return Backbone.View.prototype.remove.call(this);
        },

        render : function() {
            this.removeTrackSubViews();

            for (var i = 0; i < this.model.length; i++) {
                var dayTrack = this.model.at(i);
                this.addTrackSubView(dayTrack);
            }

            this.resetIndexes();
            this.hideWhenSingleTrack();
            return this;
        },

        hideWhenSingleTrack : function() {
            this.$el.toggle(this.model.length > 1);
        },

        addTrackSubView : function(dayTrack) {
            var trackSubView = new TrackSubView({
                model : dayTrack,
                trackSectionSubView : this
            });
            this.trackSubViews[dayTrack.cid] = trackSubView;
            trackSubView.render();
            this.$el.append(trackSubView.$el);
        },

        removeTrackSubViews : function() {
            this.trackSubViews = UTILS.removeAllSubViewsInMap(this.trackSubViews);
        },

        isSingleTrackChecked : function() {
            return this.lowerIndex === this.upperIndex;
        },

        modelTrackAdded : function(newTrack) {
            this.addTrackSubView(newTrack);
        },

        modelTrackRemoved : function(track) {
            var trackSubView = this.trackSubViews[track.cid];
            delete this.trackSubViews[track.cid];
            trackSubView && trackSubView.remove();

            var trackIndex = track.get("index");
            if (trackIndex < this.lowerIndex) {
                this.lowerIndex--;
                this.upperIndex--;
            } else if (trackIndex <= this.upperIndex) {
                this.upperIndex--;
            }
        },

        resetIndexes : function() {
            this.lowerIndex = 9999;
            this.upperIndex = -9999;
            for (var i = 0; i < this.model.length; i++) {
                var subView = this.trackSubViews[this.model.at(i).cid];
                if (subView.isChecked()) {
                    if (i < this.lowerIndex) {
                        this.lowerIndex = i;
                    }
                    if (i > this.upperIndex) {
                        this.upperIndex = i;
                    }
                }
            }
        },

        isOkToUnCheckTrack : function(track) {
            var trackIndex = track.get("index");
            return trackIndex === this.lowerIndex || trackIndex === this.upperIndex;
        },

        fillInGaps : function() {
            for (var i = this.lowerIndex; i <= this.upperIndex; i++) {
                var subView = this.trackSubViews[this.model.at(i).cid];
                if (!subView.isChecked()) {
                    subView.toggleState(true);
                }
            }
        }
    });

    var TrackSubView = Backbone.View.extend({

        events : {
            'change input' : "toggleState"
        },

        tagName : "label",
        trackSectionSubView : undefined,

        initialize : function() {
            this.trackSectionSubView = this.options.trackSectionSubView;
            this.listenTo(this.model, 'change', this.render);
            this.listenTo(this.model, 'sessionRelation:add', this.modelRelationAdded);
            this.listenTo(this.model, 'sessionRelation:remove', this.modelRelationRemoved);
        },

        render : function() {
            var html = editSessionTrackTemplate(this.model);
            this.$el.html(html);
            this.$el.addClass("trackLabel" + this.model.get("index") + " labelText checkBoxLabel");
            this.updateState();
            return this;
        },

        modelRelationAdded : function() {
            this.updateState(true);
        },

        modelRelationRemoved : function() {
            this.updateState(false);
        },

        /*
         doubly recursive with trackSectionSubView.fillInGaps
         */
        toggleState : function(doNotFillInGaps) {
            var oldState = this.isChecked();
            if (oldState && this.trackSectionSubView.isSingleTrackChecked()) {
                return; // do not allow un-checking the last track
            }
            if (oldState && (!this.trackSectionSubView.isOkToUnCheckTrack(this.model))) {
                return; // do not allow un-checking the a track when it's between 2 checked tracks
            }

            var thisRelations = this.trackSectionSubView.editSessionView.dayView.model.get("relation-session-track");
            var thisSession = this.trackSectionSubView.editSessionView.model;
            if (oldState) {
                thisRelations.removeRelation(thisSession, this.model);
            } else {
                thisRelations.addRelation(thisSession, this.model);
            }

            if (doNotFillInGaps !== true) {
                if (oldState === false) {
                    this.trackSectionSubView.fillInGaps(this.model);
                }
            }
        },

        isChecked : function() {
            return this.$el.hasClass('checkedBox');
        },

        updateState : function(state) {
            if (_.isUndefined(state)) {
                var thisRelations = this.trackSectionSubView.editSessionView.dayView.model.get("relation-session-track");
                var thisSession = this.trackSectionSubView.editSessionView.model;
                state = thisRelations.haveRelation(thisSession, this.model);
            }
            this.toggleChecked(state);
        },

        toggleChecked : function(isChecked) {
            this.$('input').attr('checked', isChecked);
            this.$el.toggleClass('checkedBox', isChecked);
        }
    });

    var SpeakersSectionSubView = Backbone.View.extend({

        speakerSubViews : {},
        editSessionView : undefined,

        initialize : function() {
            this.editSessionView = this.options.editSessionView;
            this.listenTo(this.editSessionView.model, 'speakerRelation:add', this.addSpeakerSubView);
            this.listenTo(this.editSessionView.model, 'speakerRelation:remove', this.removeSpeakerSubView);
        },

        remove : function() {
            this.removeSpeakerViews();
            return Backbone.View.prototype.remove.call(this);
        },

        render : function() {
            this.removeSpeakerViews();
            var thisAgenda = this.editSessionView.dayView.editAgendaView.model;
            var sessionsSpeakers = thisAgenda.getSpeakersForSession(this.editSessionView.model);
            for (var i = 0; i < sessionsSpeakers.length; i++) {
                var speaker = sessionsSpeakers[i];
                this.addSpeakerSubView(speaker);
            }
            return this;
        },

        addSpeakerSubView : function(speaker) {
            var speakerSubView = new SpeakerSubView({
                model : speaker,
                speakerSectionSubView : this
            });
            speakerSubView.render();
            this.$el.append(speakerSubView.$el);
            this.speakerSubViews[speaker.cid] = speakerSubView;
        },

        removeSpeakerSubView : function(speaker) {
            var speakerSubView = this.speakerSubViews[speaker.cid];
            this.speakerSubViews[speaker.cid] = undefined;
            speakerSubView && speakerSubView.remove();
        },

        removeSpeakerViews : function() {
            this.speakerSubViews = UTILS.removeAllSubViewsInMap(this.speakerSubViews);
        }
    });

    var SpeakerSubView = Backbone.View.extend({

        events : {
            'click a[name="editSpeaker"]' : "formEditSpeaker",
            'click a[name="removeSpeaker"]' : "formSpeakerRemoved"
        },

        tagName : "label",
        speakerSectionSubView : undefined,

        initialize : function() {
            this.event = Global.modelPool.getActiveEvent();
            this.speakerSectionSubView = this.options.speakerSectionSubView;
            this.listenTo(this.model, "change:first-name change:last-name change:title change:company change:photo-url", this.render);
            this.listenTo(this.model, "destroy", this.remove);
            this.listenTo(this.model, "validated", this.toggleValidation);
        },

        render : function() {
            var html = editSessionSpeakerTemplate(this.model);
            this.$el.html(html);

            if (_.isFunction(this.model.validate) && _.isFunction(this.model.isValid)) {
                this.model.validate();
            }
            return this;
        },

        formSpeakerRemoved : function() {
            var thisSession = this.speakerSectionSubView.editSessionView.model;
            this.speakerSectionSubView.model.removeRelation(thisSession, this.model);
        },

        formEditSpeaker : function() {
            this.speakerSectionSubView.editSessionView.editSpeaker(this.model, false);
        },

        toggleValidation : function() {
            var isValid = this.model.isValid();
            this.$el.find("div").toggleClass("invalid", !isValid);
        }
    });

    return EditSessionView;

});
